// extracted by mini-css-extract-plugin
export default {"fieldset":"K434KY","message":"WrstOy"};